<template>
  <v-container class="px-0 pb-5 document-form" style="background-color:#F0F0F0;min-height:500px;">
    <v-row class="d-flex ga-3 pa-2" no-gutters>
      <v-row no-gutters>
        <v-btn
            :class="{ 'secondary-button': state.tab === 'incomplete'}"
            class="b-round-20 transparent"
            @click="toggleView('incomplete')"
        >
          Incomplete
        </v-btn>
      </v-row>
      <v-row no-gutters>
        <v-btn
            :class="{ 'secondary-button': state.tab === 'completed'}"
            class="b-round-20 transparent"
            @click="toggleView('completed')"
        >
          Completed
        </v-btn>
      </v-row>
    </v-row>

    <template v-if="loading">
      <v-card v-for="n in 4" :key="n" class="mt-2 mx-2 mb-2 pa-4 border-rounded">
        <v-row class="my-0" no-gutters>
          <v-col cols="12">
            <v-row>
              <v-col class="px-3">
                <v-skeleton-loader type="text" width="70%" class="mb-2" />
                <v-skeleton-loader type="text" width="40%" />
              </v-col>
              <v-col class="text-end px-3 d-flex align-center justify-end">
                <v-skeleton-loader type="button" width="110" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <template v-else>
      <v-card v-for="document in state.items" :key="document.id" class="mt-2 mx-2 mb-2 pa-4 border-rounded">
        <v-row class="my-0" no-gutters>
          <v-col cols="12">
            <v-row>
              <v-col class="px-3">
                <p class="p-text mt-1 name">{{ document.file_resource.title }}</p>

                <p class="p-text mt-1">
                  {{ moment(document.created_at).format('DD MMM YYYY') }}
                  <span
                      v-if="moment(document.created_at).isBefore(currentDate) && state.tab === 'incomplete'"
                      class="small"
                  >
                    (Overdue)
                  </span>
                </p>
              </v-col>
              <v-col class="text-end px-3">
                <v-btn
                    :class="[{ 'view-button': state.tab === 'completed', 'complete-button': state.tab === 'incomplete' }, 'b-round-20']"
                    :color="settingsStore.settings.buttonColor"
                    @click="router.push({ name: 'form-viewer', params: { id: document.client_document.id } })"
                >
                  {{ state.tab === 'completed' ? 'View' : 'Complete Now' }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </template>

    <v-card v-if="!loading && state.items.length == 0" class="mt-2 mx-2 mb-2 pa-4">
      <v-row class="my-0" no-gutters>
        <v-col cols="12">
          <v-row class="py-2">
            <v-col class="pt-3 px-3">
              <p class="p-text mt-1">No forms available.</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>

    <div v-if="state.pagination.next_page_url" class="text-center">
      <v-btn
          :ripple="false"
          class="load-more text-capitalize font-size-12-600"
          variant="plain"
          @click="seeMore"
      >
        Load More
      </v-btn>
    </div>
  </v-container>
</template>

<script lang="ts" setup>
import {reactive, ref, shallowRef, watch} from 'vue';
import {useSettingsStore} from '@/api/store/settings';
import {useRouter} from 'vue-router';
import moment from 'moment';
import {filesService} from '@/api/services/file';

const settingsStore = useSettingsStore();
const router = useRouter();

const currentDate = moment();

const loading = ref(false);

const state = reactive({
  items: [] as any[],
  pagination: {
    meta: {},
    links: [],
    next_page_url: null,
  },
  filesLoaded: false,
  tab: 'incomplete'
});

const page = shallowRef(1)

const getFiles = (reset = false) => {
  if (reset) {
    state.items = [];
    page.value = 1;
    loading.value = true;
  }

  filesService.index({
    kind: 'form',
    page: page.value,
    completed: state.tab === 'completed' ? 1 : 0
  }).then((response) => {
    state.items.push(...response.data);
    state.pagination.meta = response.meta;
    state.pagination.links = response.links;
    state.pagination.next_page_url = response.links.next;
  }).catch((error) => {
    console.log(error);
  }).finally(() => {
    state.filesLoaded = true;
    loading.value = false;
  });
}

const toggleView = (tab: string) => {
  state.tab = tab;
  getFiles(true);
}

const seeMore = () => {
  if (state.pagination.next_page_url) {
    page.value++;
    getFiles();
  }
}

getFiles(true);
</script>